namespace app.tarefas.minhasTarefas {
    "use strict";

    import IHttpService = ng.IHttpService;
    import IHttpPromiseCallbackArg = ng.IHttpPromiseCallbackArg;
    import IPromise = ng.IPromise;
    import ILogService = ng.ILogService;
    import IDialogService = ng.material.IDialogService;
    import Properties = app.support.constants.Properties;

    const API_ROTULOS = "tasks/tags.json";
    const TYPE_DEFAULT = "AAA";
    
	declare let angular: ng.IAngularStatic;

    export class RotulosService {

        private cancelableTag: ITaskTag = <ITaskTag>{
            id: "ui:cancelable",
            tasks: [],
            name: "Cancelável",
            type: TYPE_DEFAULT,
            color: "#000000"
        };
        
        /** @ngInject **/
        constructor(private $http: IHttpService, private properties: Properties, 
            private $log: ILogService, private $mdDialog: IDialogService,
            private $q: ng.IQService) { }

        public load(task: ITask, manualTags: ITaskTag[] = []): IPromise<void> {
            return this.$http.get(`${this.properties.apiUrl}/${task.context}/${API_ROTULOS}`, {cache : true})
                .then((response: IHttpPromiseCallbackArg<ITaskTag[]>) => {
                    try {
                        task.tags = [];
                        if (angular.isArray(response.data)) {
                            response.data.push(...manualTags);
                            response.data.filter((tag) => this.filterTag(task, tag))
                                .forEach((tag) => this.pushTag(task, tag));

                            if (task.cancelable) {
                                this.pushTag(task, this.cancelableTag);
                            }
                            task.tags.sort((t1, t2) => {
                                if (t1.name > t2.name) {
                                    return 1;
                                }
                                if (t1.name < t2.name) {
                                    return -1;
                                }
                                return 0;
                            });
                        }
                    } catch(err) {
                        this.$log.error(`Erro ao carregar tags do contexto ${task.context}`);
                    }
                });
        }

        public loadManualTags(): IPromise<ITaskTag[]> {
            return this.$http.get<ITaskTag[]>(`${this.properties.apiUrl}/integracoes-tarefas/api/tags`)
                .then(response => {
                    response.data.forEach(t => {
                        t.tasks = [ t.id ];
                        t.type = (!t.type) ? "Manuais" : t.type;
                    });
                    return response.data;
                }, () => []);
        }

        public create(tag: ITaskTag): IPromise<ITaskTag> {
            return this.$http({
                    method: "post",
                    url: `${this.properties.apiUrl}/integracoes-tarefas/api/tags`,
                    data: tag,
                    transformResponse: (value) => value
                })
                .then(response => {
                    return <ITaskTag> {
                        id: response.data,
                        name: tag.name,
                        tasks: [ response.data ],
                        color: tag.color,
                        tooltip: tag.tooltip,
                        tenantsPermitidos: tag.tenantsPermitidos,
                        type : "Manuais"
                    };
                });
        }

        public update(tag: ITaskTag): ng.IPromise<void> {
            let cmd = {
                id: tag.id,
                name: tag.name,
                color: tag.color
            };            
            return this.$http.put<void>(`${this.properties.apiUrl}/integracoes-tarefas/api/tags/${tag.id}`, cmd)
                .then(response => response.data);
        }

        public remove(tags: string[]): ng.IPromise<string[]> {
            let deletes = tags.map(tag =>
                 this.$http.delete<void>(`${this.properties.apiUrl}/integracoes-tarefas/api/tags/${tag}`));
            
            return this.$q.all(deletes)
                .then(() => tags);
        }
        
        private pushTag(task: ITask, tag: ITaskTag): void {
            if (!tag.type) {
                tag.type = TYPE_DEFAULT;
            }
            task.tags.push(tag);
        }
        
        private filterTag(task: ITask, tag: ITaskTag): boolean {
            return tag.tasks.indexOf(task.command) > -1 || 
                    (!!task.etags && tag.tasks.some((t) => task.etags.indexOf(t) > -1));
        }
    }

    angular
        .module("app.tarefas.minhas-tarefas")
        .service("app.tarefas.minhas-tarefas.RotulosService", RotulosService);
}